//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useContext, useEffect, useState } from "react"
import { useParams } from 'react-router';

// === API ===
import { on, removeListener, sendMessageData } from "api/prokey/prokey.websocket";

//#endregion

const ContextFile = createContext();

//-----------------------------------------------------------------
export function FileProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const route_params = useParams();
  const file_id = parseInt( route_params.file_id );
  const [ loan_number , setLoanNumber ] = useState( '' );
  const [ is_loading  , setIsLoading ] = useState( true );

  const values = {
    file_id,
    loan_number,
    is_loading,
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleTask(data) {
      //-----------------------------------------------------------------
      if( !data.is_loading ) {
        setLoanNumber( data.loan_number );
        setIsLoading( false );
      }
    }
    //-----------------------------------------------------------------
    function handleConnection() {
      //-----------------------------------------------------------------
      sendMessageData( 'FILE', { file_id } )
    }

    on( 'FILE', handleTask );
    on( 'connection', handleConnection)

    sendMessageData( 'FILE', { file_id } )

    return () => {
      removeListener( 'FILE' , handleTask );
      removeListener( 'connection' , handleConnection );
    };
  }, [] )
  
  useEffect( () => {
    return () => {
      sendMessageData( 'FILE_CLOSE', { file_id } )
    }
  }, [file_id] )
  
  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []); // empty dependency = called only once at startup

  //#endregion
  
  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onKeyDown(event) {
    //-----------------------------------------------------------------
    if(false) {}
    // Comparison Image
    else if ( event.key === 'PageUp' && event.shiftKey ) {
      event.preventDefault();
      event.stopPropagation();
      sendMessageData( 'FILE_COMPARISON_IMAGE_SELECT_PREV', { file_id: file_id } )
    }
    else if ( event.key === 'PageDown' && event.shiftKey ) {
      event.preventDefault();
      event.stopPropagation();
      sendMessageData( 'FILE_COMPARISON_IMAGE_SELECT_NEXT', { file_id: file_id } )
    }
    // Primary Image
    else if ( event.key === 'PageUp' ) {
      event.preventDefault();
      event.stopPropagation();
      sendMessageData( 'FILE_IMAGE_SELECT_PREV', { file_id: file_id } )
    }
    else if ( event.key === 'PageDown' ) {
      event.preventDefault();
      event.stopPropagation();
      sendMessageData( 'FILE_IMAGE_SELECT_NEXT', { file_id: file_id } )
    }
  }

  //#endregion

  return (
    <ContextFile.Provider value={ values }>
      {children}
    </ContextFile.Provider>
  );
};

//-----------------------------------------------------------------
export function useFile() {
  //-----------------------------------------------------------------
  return useContext( ContextFile );
}